export default __webpack_public_path__ + "img/879b2f2a6a1b27b7ff4a51e2ef85018a.png";